/**
 * Props for an empty state.
 *
 * @since 1.0.0
 */
export interface EmptyStateProps {
    title: string;
    detail: string;
}

/**
 * What a card shows when it has nothing to list: a bold line saying so and a quiet line
 * saying what to do about it.
 *
 * @since 1.0.0
 * @param props - the headline and the suggested next step
 * @returns the empty state element
 */
export function EmptyState({ title, detail }: EmptyStateProps) {
    return (
        <div className="fkwd-empty">
            <span className="fkwd-empty__title">{title}</span>
            {detail}
        </div>
    );
}
